import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { api, toastError } from "../../lib/api";
import { AlertTriangle, LogOut } from "lucide-react";
import { toast } from "sonner";

export function SupportBanner() {
  const { supportSession, setSupportSession } = useAuth();
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);

  if (!supportSession) return null;

  const exitSupportAccess = async () => {
    setExiting(true);
    try {
      await api.post(`/support-access/${supportSession.id}/revoke`);
      toast.success("Support access ended");
    } catch (error) {
      toastError(error, "Could not revoke the support session");
      return;
    } finally {
      setExiting(false);
    }
    setSupportSession(null);
    navigate("/platform/support-access");
  };

  return (
    <div
      data-testid="support-access-banner"
      className="w-full bg-yellow-400 text-yellow-950 border-b border-yellow-500 py-2 px-4 flex flex-wrap items-center justify-center gap-3 text-xs font-semibold uppercase tracking-widest sticky top-0 z-50"
      style={{
        backgroundImage:
          "repeating-linear-gradient(45deg, rgba(0,0,0,0.04) 0 8px, transparent 8px 16px)",
      }}
    >
      <AlertTriangle className="w-4 h-4" />
      <span>
        Support Access Active — Tenant: {supportSession.tenant_name || `${supportSession.tenant_id?.slice(0, 8)}…`} · Expires {new Date(supportSession.expires_at).toLocaleTimeString()}
      </span>
      <button
        type="button"
        onClick={exitSupportAccess}
        disabled={exiting}
        data-testid="exit-support-access"
        className="inline-flex items-center gap-1 rounded-md border border-yellow-950/30 bg-yellow-50/70 px-2.5 py-1 normal-case tracking-normal hover:bg-white disabled:opacity-60"
      >
        <LogOut className="h-3.5 w-3.5" />
        {exiting ? "Exiting…" : "Exit support access"}
      </button>
    </div>
  );
}
